module.exports = __webpack_public_path__ + "MuseoSans-700Italic.9c0de31ae7d28f21b7ca.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-700Italic.ttf
// module id = ../../../../../src/assets/fonts/MuseoSans-700Italic.ttf
// module chunks = styles